import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const termsData = [
  {
            label: "1. Agreement to Terms",
            text: "Your use of the App constitutes a binding legal agreement between you and DARS Transtrade Private Limited. These Terms govern your access to and use of the App and its features."
          },
          {
            label: "2. Eligibility",
            text: "Users must be 18 years or older, or have parental consent, to access the App. By using the App, you represent that you meet this requirement."
          },
          {
            label: "3. Account Registration",
            text: "Certain features may require registration. You are responsible for the accuracy of information and for keeping your login credentials confidential."
          },
          {
            label: "4. Permitted Use",
            text: "You agree to use the App in accordance with applicable laws and refrain from any misuse, including attempting to gain unauthorized access or disrupting the service."
          },
          {
            label: "5. Intellectual Property",
            text: "All intellectual property related to the App, including content, software, and trademarks, is owned by DARS Transtrade Private Limited or its licensors. Unauthorized reproduction is strictly prohibited."
          },
          {
            label: "6. Data & Privacy",
            text: "Use of the App is subject to our Privacy Policy. Please review it to understand how we handle your data."
          },
          {
            label: "7. Third-Party Links",
            text: "The App may include links to external websites or services. We are not responsible for their content or practices."
          },
          {
            label: "8. Disclaimer of Warranty",
            text: 'The App is provided "as is" without warranties of any kind, express or implied. We do not guarantee the accuracy, availability, or reliability of any feature.'
          },
          {
            label: "9. Limitation of Liability",
            text: "In no event shall DARS Transtrade Private Limited be liable for any indirect, incidental, or consequential damages arising out of your use or inability to use the App."
          },
          {
            label: "10. Governing Law",
            text: "These Terms are governed by the laws of India. All disputes shall be subject to the jurisdiction of courts located in Mumbai, Maharashtra."
          },
          {
            label: "11. Changes to the Terms",
            text: "We may modify these Terms from time to time. Updated terms will be posted in the App. Continued use implies acceptance."
          },
          {
            label: "12. Contact Us",
            text: "If you have any questions, please contact us at:\n📞 +91 99114 43468\n📧 harish@mapwala.in"
          }
];

export default function TermsAndConditions() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        // backgroundColor: "#F3F4F6",
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "20px",
            p: { xs: 3, md: 5 },
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: 2,
              mb: 4,
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "18px", md: "36px" },
                fontWeight: 700,
                color: "#0F2342",
                lineHeight: 1.2,
              }}
            >
             Mapwala App - Terms & Conditions
            </Typography>

            <Typography
              sx={{
                color: "#6B7280",
                fontSize: "18px",
                mt: 1,
              }}
            >
              Last Updated: 21.08.2025
            </Typography>
          </Box>

          {/* Intro Text */}
          <Typography
            sx={{
              color: "#334155",
              fontSize: "17px",
              lineHeight: 1.8,
              mb: 5,
            }}
          >
            Welcome to Mapwala, a digital platform operated by DARS
            Transtrade Private Limited, headquartered at 22 Manek Mahal,
            90 Veer Nariman Road, Next to Ambassador Hotel, Mumbai 400020.
            These Terms and Conditions ("Terms") govern your use of the
            Mapwala mobile application ("App"). By accessing or using the
            App, you agree to be bound by these Terms. If you do not agree
            with any part of these Terms, please do not use the App.
          </Typography>

          {/* Accordions */}
          {termsData.map((item, index) => (
            <Accordion
              key={index}
              defaultExpanded={index === 0}
              disableGutters
              elevation={0}
              sx={{
                mb: 3,
                borderRadius: "14px !important",
                overflow: "hidden",
                backgroundColor: "#F3F4F6",
                "&:before": {
                  display: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{
                      color: "#4B5563",
                      fontSize: 32,
                    }}
                  />
                }
                sx={{
                  px: 3,
                  py: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#0F2342",
                  }}
                >
                  {item.label}
                </Typography>
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  px: 3,
                  pb: 3,
                }}
              >
                <Typography
                  sx={{
                    color: "#475569",
                    fontSize: "16px",
                    lineHeight: 1.8,
                  }}
                >
                  {item.text}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Container>
    </Box>
  );
}